import React, { useRef, useState } from 'react';
import userImg from '../../../assets/images/user.png'
import closeIcon from '../../../assets/icons/close_icon.svg'
import Modal from "react-bootstrap/Modal";
import post from '../../../assets/images/posts/post_img.jpg'
import { Link } from 'react-router-dom';
import config from '../../../config.json'
import videoPlay from '../../../assets/icons/video_play_icon.svg'
import redHeartIcon from '../../../assets/icons/red-heart-icon-filled.svg'
import heartIconBordered from '../../../assets/icons/heart-icon-bordered.svg';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import SpinnerLoader from '../../../components/common/SpinnerLoader';
import { setLoading } from '../../../store/reducers/global-reducer';
import { getPostsData } from '../../../helpers/post-listing';
import { updatePostInFeed } from '../../../store/reducers/post-reducer';
import SimpleImageSlider from "react-simple-image-slider";
import { CommunityAdvertise } from '../../common/BannerFrame';
import ReactTimeAgo from 'react-time-ago'
import TimeAgo from 'javascript-time-ago'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import io from "socket.io-client";

import en from 'javascript-time-ago/locale/en.json'
import ru from 'javascript-time-ago/locale/ru.json'

// TimeAgo.addDefaultLocale(en) 
// TimeAgo.addLocale(ru)


const Post = ({ posts, sendEditData, sendShareData }) => {
    // console.log("posts", posts)
    const authInfo = useSelector(state => state.auth.authInfo);
    const userInfo = useSelector(state => state.auth.userInfo);
    const loading = useSelector(state => state.global.loading);
    const dispatch = useDispatch();
    const [comments, setComments] = useState('');
    const [commentsArr, setCommentsArr] = useState(posts.comments);
    const [newCommentsArr, setNewCommentsArr] = useState([]);
    const [commentsCount, setCommentsCount] = useState(posts.commentCount);
    const [commentsToShow, setCommentsToShow] = useState(2);
    const [isReadMore, setIsReadMore] = useState(true);
    const [likes, setLikes] = useState(posts.likeCount);
    const [filteredLikes, setFilteredLikes] = useState([]);
    const [isLikedByMe, setIsLikedByMe] = useState(false);
    const [likesArr, setLikesArr] = useState(posts.likes);
    const [openModal, setOpenModel] = useState(false);
    const [openShare, setOpenShare] = useState(false);
    const [showSingleImg, setShowSingleImg] = useState(false);
    const [tempImg, setTempImg] = useState('');
    const [sliderImages, setSliderImages] = useState([]);
    const [sliderVideos, setSliderVideos] = useState([]);
    const [ShowSlider, setShowSlider] = useState(false);
    const [isFollowing, setIsFollowing] = useState(false);
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [reportedPost, setReportedPost] = useState(null);
    const [reportNote, setReportNote] = useState(null);
    const [reportOption, setReportOption] = useState(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [selectedPostId, setSelectedPostId] = useState(null);
    const [isCommentsOpen, setIsCommentsOpen] = useState(false);
    const date = new Date(posts.createdAt);
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    const currentUserId = authInfo.id;
    const userIdToSend = posts.adminId ? posts.adminId.id : posts.userId ? posts.userId?.id : posts.sellerId?.id;
    const adminIdToSend = process.env.REACT_APP_SUPPER_ADMIN_ID;
    const receiverRole = posts.adminId ? posts.adminId.role : posts.userId ? posts.userId.role : posts.sellerId ? posts.sellerId.role : null;

    const handleComments = (e) => {
        setComments(e.target.value);
    }

    const toggleCommentCollapse = (e) => {
        if (e) {
            e.preventDefault();
        }
        setIsCommentsOpen((prev) => !prev);
    };

    const closeComments = (e) => {
        if (e) {
            e.preventDefault();
        }
        setIsCommentsOpen(false);
    };

    const patchPostInFeed = (updates) => {
        dispatch(updatePostInFeed({ postId: posts.id, updates }));
    };

    const buildCommentForDisplay = (content, apiData = {}) => ({
        content,
        createdAt: apiData.createdAt || new Date().toISOString(),
        isSeller: userInfo.role !== 'user',
        isAdmin: false,
        userId: userInfo.role === 'user' ? {
            id: authInfo.id,
            name: userInfo.name,
            image_url: userInfo.imgUrl,
        } : null,
        sellerId: userInfo.role === 'seller' ? {
            id: authInfo.id,
            name: userInfo.name,
            image_url: userInfo.imgUrl,
        } : null,
    });

    const addNewComment = (postId) => {
        const commentContent = comments.trim();
        if (!commentContent) {
            return;
        }

        let reqBody = {};
        if (userInfo.role === 'user') {
            reqBody = {
                content: commentContent,
                isSeller: false,
                user_id: authInfo.id,
                seller_id: null
            }
        }
        else {
            reqBody = {
                content: commentContent,
                isSeller: true,
                user_id: null,
                seller_id: authInfo.id
            }
        }
        setComments('');
        axios.post(`community/postComments/${postId}`, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                const newComment = buildCommentForDisplay(commentContent, response.data.data || {});
                const updatedComments = [...commentsArr, newComment];
                const newCount = commentsCount + 1;
                setCommentsArr(updatedComments);
                setCommentsCount(newCount);
                patchPostInFeed({ comments: updatedComments, commentCount: newCount });
                setIsCommentsOpen(true);
                //***************** */
                const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);
                const notification = {
                    message: `${userInfo.name} comment on your post: "${commentContent}"`,
                    postId: postId,
                    sender: { id: currentUserId, name: userInfo.name },
                    receiver: { id: userIdToSend, name: posts.adminId ? posts.adminId?.name : posts.userId ? posts.userId?.name : posts.sellerId?.name },
                    type: 'comment'
                };
                socket.emit('comment', {
                    notification                  
                });

                const notificationReqBody = {
                    type: 'comment',
                    sender: {
                        id: currentUserId,
                        type: 'user'

                    },
                    receiver: {
                        id: userIdToSend,
                        type: receiverRole
                    },
                    postId: postId,
                    message: `${userInfo.name} comment on your post: "${commentContent}"`,
                    isRead: 'false',
                    createdAt: new Date(),
                };
                axios.post('front/notifications', notificationReqBody).then(response => {
                    console.log("Notification saved:", response.data.message);
                }).catch(error => {
                    console.log("Error saving notification:", error);
                });
                //***************** */

            }
        }).catch(error => {
            console.log(error);
            toast.error('Unable to add comment.');
        });
    }

    const removeFromLiked = (postId, e) => {
        if (e) {
            e.preventDefault();
        }
        const updatedLikes = [...filteredLikes];
        const index = updatedLikes.indexOf(authInfo.id);
        if (index > -1) {
            updatedLikes.splice(index, 1);
        }
        setFilteredLikes(updatedLikes);
        setIsLikedByMe(false);
        const newLikeCount = Math.max(0, likes - 1);
        setLikes(newLikeCount);
        patchPostInFeed({ likeCount: newLikeCount });
        let reqBody = {};
        if (userInfo.role === 'user') {
            reqBody = {
                isLike: false,
                isSeller: false,
                user_id: authInfo.id,
                seller_id: null
            }
        }
        else {
            reqBody = {
                isLike: false,
                isSeller: true,
                user_id: null,
                seller_id: authInfo.id
            }
        }
        axios.post(`community/postLikes/${postId}`, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        }).then(response => {
            if (!response.data.status) {
                setFilteredLikes(filteredLikes);
                setIsLikedByMe(true);
                setLikes(likes);
                patchPostInFeed({ likeCount: likes });
            }
        }).catch(error => {
            console.log(error);
            setFilteredLikes(filteredLikes);
            setIsLikedByMe(true);
            setLikes(likes);
            patchPostInFeed({ likeCount: likes });
        });

    }
    const addToLiked = (postId, e) => {
        if (e) {
            e.preventDefault();
        }
        const updatedLikes = [...filteredLikes, authInfo.id];
        setFilteredLikes(updatedLikes);
        setIsLikedByMe(true);
        const newLikeCount = likes + 1;
        setLikes(newLikeCount);
        patchPostInFeed({ likeCount: newLikeCount });
        let reqBody = {};
        if (userInfo.role === 'user') {
            reqBody = {
                isLike: true,
                isSeller: false,
                user_id: authInfo.id,
                seller_id: null
            }
        }
        else {
            reqBody = {
                isLike: true,
                isSeller: true,
                user_id: null,
                seller_id: authInfo.id
            }
        }
        axios.post(`community/postLikes/${postId}`, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                //***************** */
                const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);
                const notification = {
                    message: `${userInfo.name} likes your post`,
                    postId: postId,
                    sender: { id: currentUserId, name: userInfo.name },
                    receiver: { id: userIdToSend, name: posts.adminId ? posts.adminId.name : posts.userId ? posts.userId?.name : posts.sellerId?.name },
                    type: 'like'
                };
                // Emit liked notification to the user
                socket.emit('liked', {
                    notification
                });

                const notificationReqBody = {
                    type: 'like',
                    sender: {
                        id: currentUserId,
                        type: 'user'

                    },
                    receiver: {
                        id: userIdToSend,
                        type: receiverRole
                    },
                    postId: postId,
                    message: `${userInfo.name} likes on your post`,
                    isRead: 'false',
                    createdAt: new Date(),
                };

                axios.post('front/notifications', notificationReqBody).then(response => {
                    console.log("Notification saved:", response.data.message);
                }).catch(error => {
                    console.log("Error saving notification:", error);
                });
                //***************** */

            } else {
                setFilteredLikes(filteredLikes);
                setIsLikedByMe(false);
                setLikes(likes);
                patchPostInFeed({ likeCount: likes });
            }
        }).catch(error => {
            console.log(error);
            setFilteredLikes(filteredLikes);
            setIsLikedByMe(false);
            setLikes(likes);
            patchPostInFeed({ likeCount: likes });
        });
    }

    const viewMoreComments = (id) => {
        let initialCommentToShow = commentsToShow;
        if (posts.id === id) {
            initialCommentToShow = initialCommentToShow + 2;
        }
        setCommentsToShow(initialCommentToShow);
    }
    const handleImgShow = (img) => {
        setTempImg(img);
        setShowSingleImg(true);
    }
    const handleSliderShow = (item) => {
        setTempImg(item.url);
        if (posts.postImages.length > 0) {
            let sliderImages = [{ url: item.url }];
            posts.postImages.filter((val) => val.url !== item.url).forEach((value) => {
                sliderImages.push({ url: value.url });
            });
            setSliderImages(sliderImages);
        }
        if (posts.postVideos.length > 0) {
            let sliderVideos = [{ url: item.url }];
            posts.postVideos.forEach((value) => {
                sliderVideos.push({ url: value.url });
            });
            setSliderVideos(sliderVideos);
        }
        setShowSlider(true)
    }
    const hideSlider = () => {
        setShowSlider(false)
        setSliderImages([]);
        setSliderVideos([]);
    }
    const handleModel = () => {
        setOpenModel(true);
    }
    let followRef = useRef();
    let shareRef = useRef();
    useEffect(() => {
        setCommentsArr(posts.comments || []);
        setCommentsCount(posts.commentCount);
        setLikes(posts.likeCount);
    }, [posts.id]);

    useEffect(() => {
        const likedIds = [];
        (posts.likes || []).forEach((value) => {
            if (value.isSeller === true && value.sellerId?.id) {
                likedIds.push(value.sellerId.id);
            } else if (value.userId?.id) {
                likedIds.push(value.userId.id);
            }
        });
        setFilteredLikes(likedIds);
        setIsLikedByMe(likedIds.some((id) => String(id) === String(authInfo.id)));
    }, [posts.id, posts.likes, authInfo.id]);

    // useEffect(() => {
    //     if (posts.postImages.length > 0) {
    //         let sliderImages = [];
    //         posts.postImages.forEach((value) => {
    //             sliderImages.push({ url: config.apiURI + value.url })
    //         });          
    //         setSliderImages(sliderImages);
    //     }
    // }, []);

    useEffect(() => {
        let followHandler = (event) => {
            if (!followRef.current.contains(event.target)) {
                setOpenModel(false);
            }
        }
        document.addEventListener("mousedown", followHandler)
        return () => {
            document.removeEventListener("mousedown", followHandler)
        }
    });
    useEffect(() => {
        let shareHandler = (event) => {
            if (!shareRef.current.contains(event.target)) {
                setOpenShare(false);
            }
        }
        document.addEventListener("mousedown", shareHandler)
        return () => {
            document.removeEventListener("mousedown", shareHandler)
        }
    });

    const handleFollow = (posts) => {
        const currentUserId = authInfo.id;
        const userIdToFollow = posts.userId === null ? posts.sellerId.id : posts.userId.id;
        const role = posts.userId === null ? posts.sellerId.role : posts.userId.role;
        const receiverRole = posts.adminId ? posts.adminId.role : posts.userId ? posts.userId.role : posts.sellerId ? posts.sellerId.role : null;

        var reqBody = {
            role: role,
            currentUserId: currentUserId,
            userIdToFollow: userIdToFollow,
        }
        axios.post(`community/follow-user`, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                getPostsData(dispatch);
                setIsFollowing(true);
                // console.log("response", response.data.message);
                toast.success(response.data.message);
                const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);

                // Emit follow notification to the followed user
                socket.emit('follow', {
                    follower: { id: currentUserId, name: userInfo.name },
                    followed: { id: userIdToFollow, name: posts.userId === null ? posts.sellerId?.name : posts.userId?.name },
                });

                const notificationReqBody = {
                    type: 'follow',
                    sender: {
                        id: currentUserId,
                        type: 'user'

                    },
                    receiver: {
                        id: userIdToFollow,
                        type: receiverRole
                    },
                    message: `${userInfo.name} followed you.`,
                    isRead: 'false',
                    createdAt: new Date(),
                };

                // axios.post('community/notifications', notificationReqBody, {
                axios.post('front/notifications', notificationReqBody, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': `Bearer ${authInfo.token}`
                    }
                }).then(response => {
                    console.log("Notification saved:", response.data.message);
                }).catch(error => {
                    console.log("Error saving notification:", error);
                });

            }
        }).catch(error => {
            console.log(error);
        });
    }

    const handleUnfollow = (posts) => {
        const currentUserId = authInfo.id;
        // const userIdToUnfollow = posts.userId.id;
        const userIdToUnfollow = posts.userId === null ? posts.sellerId.id : posts.userId.id;
        const role = posts.userId === null ? posts.sellerId.role : posts.userId.role;
        var reqBody = {
            role: role,
            currentUserId: currentUserId,
            userIdToUnfollow: userIdToUnfollow,
        }
        axios.post(`community/unfollowUser`, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                // console.log("response", response.data.message);
                toast.success(response.data.message);
                setIsFollowing(false);
                getPostsData(dispatch);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    const handleRemove = (postId) => {
        const reqBody = { postId };

        axios
        .put(`community/postRemoved`, reqBody, {
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${authInfo.token}`,
            },
        })
        .then((response) => {
            if (response.data.status) {
            toast.success(response.data.message);
            getPostsData(dispatch);
            }
        })
        .catch((error) => {
            console.log(error);
            toast.error("Failed to delete post");
        })
        .finally(() => {
            setIsConfirmOpen(false);
            setSelectedPostId(null);
        });
    };

    const confirmDelete = (postId) => {
        setSelectedPostId(postId);
        setIsConfirmOpen(true);
    };


    const handleEdit = (postEditData) => {
        sendEditData(postEditData);
    }

    useEffect(() => {
        // Function to fetch data
        const fetchData = () => {
            let response = false;
            if (posts.userId?.community?.followerData) {
                response = posts.userId.community.followerData.includes(authInfo.id);
            } else if (posts.sellerId?.community?.followerData) {
                response = posts.sellerId.community.followerData.includes(authInfo.id);
            } else if (posts.adminId?.community?.followerData) {
                response = posts.adminId.community.followerData.includes(authInfo.id);
            }
            setIsFollowing(response);
        };
        fetchData();
    }, []);

    const handleShare = () => {
        setOpenShare(true)
    }

    const handleFacebookShare = (postId) => {
        // const url = `https://pay.earth/share_community/${postId}`
        const url = `https://pay.earth/share_community/${postId}`
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(facebookShareUrl, '_blank');
    };

    const handleXShare = (postId) => {
        // const { shareAdvertise } = this.state;
        const url = `https://pay.earth/share_community/${postId}`
        // const url = `https://localhost:3000/share_community/${postId}`
        const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
        window.open(twitterShareUrl, '_blank');
    };

    const handleInstagramShare = (postId) => {
        // const { shareAdvertise } = this.state;
        const url = `https://pay.earth/share_community/${postId}`
        // const url = `https://localhost:3000/share_community/${postId}`
        const instagramShareUrl = `https://www.instagram.com/?url=${url}`
        window.open(instagramShareUrl, '_blank');
    };

    const handleWhatsappShare = (postId) => {
        // const { shareAdvertise } = this.state;
        const caption = encodeURIComponent(`https://pay.earth/share_community/${postId}`);
        // const caption = encodeURIComponent(`https://localhost:3000/share_community/${postId}`);
        const whatsappShareUrl = `https://api.whatsapp.com/send?text=${caption}`;
        window.open(whatsappShareUrl, '_blank');
    }

    const handleReportPopup = (post) => {
        setIsReportOpen(true);
        setReportedPost(post)
    }

    const reportPopupClose = () => {
        setIsReportOpen(false);
        setReportedPost(null);
    }

    const handleReportPost = async () => {
        try {
            const data = reportedPost;
            const postUserName = data.userId ? data.userId.name : data.sellerId.name;
            console.log("Reported post sent to admin:", data);

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authInfo.token}`
            };

            const reportData = {
                postId: data.id,
                postCreatedBy: data.userId ? data.userId.id : data.sellerId.id,
            };

            const response = await axios.post(
                'community/createPostReport',
                {
                    reportType: reportOption,
                    notes: reportNote,
                    reportData,
                    reportBy: authInfo.id
                },
                { headers }
            );

            // Handle the response
            console.log("response", response)
            if (response.data.status === true) {
                toast.success("Report Successfully sent");
                setIsReportOpen(false);
                setReportedPost(null);


                //***************** */
                const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);
                const notification = {
                    message: `${userInfo.name} Report on "${postUserName}" post : "${reportOption}"`,
                    postId: data.id,
                    sender: { id: currentUserId, name: userInfo.name },
                    receiver: { id: adminIdToSend },
                    type: 'report'
                };
                console.log('Report notification---', notification)
                // Emit Report notification to the user
                socket.emit('Report', {
                    notification
                });

                const notificationReqBody = {
                    type: 'report',
                    sender: {
                        id: currentUserId,
                        type: 'user'

                    },
                    receiver: {
                        id: adminIdToSend,
                        type: 'admin'
                    },
                    postId: data.id,
                    message: `${userInfo.name} Report on "${postUserName}" post : "${reportOption}"`,
                    isRead: 'false',
                    createdAt: new Date(),
                };

                axios.post('front/notifications', notificationReqBody).then(response => {
                    console.log("Notification saved:", response.data.message);
                }).catch(error => {
                    console.log("Error saving notification:", error);
                });
                //***************** */


            } else {
                toast.error("Failed to send report. Please try again.");
            }
        } catch (error) {
            console.error('Error reporting post:', error);
            toast.error("An error occurred while reporting the post.");
        }
    };

    const handleBlockUser = async (data) => {
        const selectedUserId = data.userId === null ? data.sellerId.id : data.userId.id
        try {
            const authorId = authInfo.id
            const url = "community/communityUserBlock";
            axios.put(url, { authorId, selectedUserId }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            }).then((response) => {
                if (response.data.status === true) {

                    getPostsData(dispatch);
                    toast.success("user blocked..");
                    handleUnfollow(data);
                }
            }).catch((error) => {
                console.log("error", error)
            })

        } catch (error) {
            console.error('Error', error);
        }
    }


    const handleNoteChange = (e) => {
        setReportNote(e.target.value);
    };

    const handleOptionChange = (e) => {
        setReportOption(e.target.value);
    };

    const settings = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: posts.postImages.length === 1 ? 1 : 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: posts.postImages.length === 1 ? 1 : 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <React.Fragment>

            {/* {loading === true ? <SpinnerLoader /> : ''} */}
            <div className="post">
                <div className="post_head">
                    <div className="post_by">
                        <div className="poster_img">
                            <img
                                src={
                                    posts.isAdmin && posts.adminId?.image_url ? posts.adminId.image_url :
                                        posts.userId === null || posts.userId === undefined ?
                                            (posts.sellerId?.image_url ? posts.sellerId.image_url : userImg) :
                                            (posts.userId?.image_url ? posts.userId.image_url : userImg)
                                }
                                alt=""
                            />
                        </div>
                        <div className="poster_info">
                            <div className="poster_name">
                                {posts.isAdmin ? posts.adminId.name : posts.isSeller ? posts.sellerId?.name : posts.userId?.name}
                            </div>
                            <ReactTimeAgo date={date} locale="en-US" timeStyle="round-minute" />
                            {/* <Link className="post_follow" data-bs-toggle="collapse" to={`#collapseFollow${posts.id}`} role="button" aria-expanded="false" aria-controls={`collapseFollow${posts.id}`}>
                                Follow
                            </Link> */}
                            {
                                userInfo.role === 'seller' && posts.isAdmin === false &&
                                <Link to="#" className="post_follow" onClick={() => handleModel()}>
                                    {posts.isSeller === true && posts.sellerId?.id === authInfo.id
                                        ? "" : isFollowing ? 'Unfollow' : 'Follow'}
                                </Link>
                            }
                            {
                                userInfo.role === 'user' && posts.isAdmin === false &&
                                <Link to="#" className="post_follow" onClick={() => handleModel()}>
                                    {posts.isSeller === false && posts.userId?.id === authInfo.id ? "" : isFollowing ? 'Unfollow' : 'Follow'}
                                </Link>
                            }
                            {
                                posts.isAdmin === true &&
                                <span className="post_admin text-success">Admin</span>
                            }
                        </div>
                    </div>
                    <div ref={followRef}>
                        {
                            openModal ?
                                <div className={`post_follow_pop`}>
                                    <div className="follow_box">
                                        <div className="post_by">
                                            <div className="poster_img" ><img src={posts.isSeller ? posts.sellerId.image_url : posts.userId.image_url !== null ? posts.userId.image_url : userImg} alt="" /></div>
                                            <div className="poster_info">
                                                <div className="poster_name">{posts.isSeller ? posts.sellerId?.name : posts.userId?.name}</div>
                                                <small>{posts.isSeller ? 'Seller' : 'User'}</small>
                                            </div>
                                        </div>
                                        <ul>
                                            <li>
                                                <div className="fp_fc">{posts.userId === null ? posts.sellerId.community.followers : posts.userId.community.followers}</div>
                                                <small>Followes</small>
                                            </li>
                                            <li>
                                                <div className="fp_fc">{posts.userId === null ? posts.sellerId.community.following : posts.userId.community.following}</div>
                                                <small>Following</small>
                                            </li>
                                        </ul>
                                        <div className="text-center">
                                            {isFollowing ?
                                                <Link to="#" className="btn custom_btn btn-info" onClick={() => handleUnfollow(posts)}>Unfollow</Link>
                                                :
                                                <Link to="#" className="btn custom_btn btn-info" onClick={() => handleFollow(posts)}>Follow</Link>
                                            }
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                    <div className="post_on">
                        {/* Date : {`${date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`} - ${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`} - ${date.getFullYear()}`} */}
                        {/* {date.toLocaleDateString("en-US", options)} */}
                        {/* <ReactTimeAgo date={date} locale="en-US" timeStyle="twitter"/> */}
                        {/* <span>{posts.productId !== null || posts.categoryId !== null ? '|' : ''}</span> */}
                        {
                            posts.productId !== null || posts.categoryId !== null ?
                                // <span>{Object.keys(posts.productId).length ? 'Product' : 'Category'} : {Object.keys(posts.productId).length ? `${posts.productId.name}` : `${posts.categoryId.name}`}</span>
                                <>{posts.productId !== null ? 'Product' : 'Category'} : {posts.productId !== null ? <Link to={`product-detail/${posts.productId.id}`}>{posts.productId.name}</Link> : <Link to={`product-listing?cat=${posts.categoryId.id}&search=`}>{posts.categoryId.categoryName}</Link>}</>
                                : ''
                        }
                    </div>
                </div>
                <div className="post_body">
                    <div className="post_text">
                        <p>{isReadMore ? posts.postContent.slice(0, 150) : posts.postContent}
                            {
                                posts.postContent.length > 150 ?
                                    <span onClick={() => setIsReadMore(!isReadMore)} className="read-or-hide">
                                        {isReadMore ? "...read more" : " show less"}
                                    </span>
                                    : ''
                            }
                        </p>
                    </div>
                    {/* post images */}
                    <div className={`post_single_img ${showSingleImg ? 'open' : ''}`}>
                        <img className='single_img' src={tempImg} alt="" />
                        <i className='icon' onClick={() => setShowSingleImg(false)}><img src={closeIcon} alt="" /></i>
                        {/* <button type="button" className="view_more text-reset"><img src={closeIcon} className="img-fluid" alt="close_icon" /> Close</button> */}
                    </div>
                    {/* slider begin */}
                    {sliderImages.length > 0 &&
                        <div className={`post_single_img ${ShowSlider ? 'open' : ''}`} >
                            {/* <i className='icon' onClick={() => hideSlider()} ><img src={closeIcon} alt="" /></i> */}
                            <button type="button" className="btn-close" onClick={() => hideSlider()}></button>
                            <SimpleImageSlider
                                width={1000}
                                height={800}
                                images={sliderImages}
                                // showBullets={true}
                                showNavs={true}
                                style={{ backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}
                            />
                        </div>
                    }

                    <div className="commVideoSlider destopHidden">
                        <Slider {...settings}>
                            {posts.postImages.map((image, ind) => {
                                return (
                                    <div
                                        className={`post_child_div ${posts.postImages.length === 1 ? 'col-12' : 'col-md-6'}`}
                                        key={ind}
                                        onClick={() => handleSliderShow(image)}
                                    >
                                        <div className="post_img mb-3">
                                            <img src={image.url} alt={`Slide ${ind + 1}`} />
                                        </div>
                                    </div>
                                );
                            })}
                            {posts.postVideos.map((video, ind) => {
                                return (
                                    <div
                                        className={`post_main_div ${posts.postVideos.length === 1 ? 'col-12' : 'col-md-4'}`} key={ind + 5}
                                        onClick={() => handleSliderShow(video)}
                                    >
                                        <div className="post_img mb-3 ">
                                            <video controls>
                                                <source src={video.url}
                                                    autoPlay
                                                    loop
                                                    type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>
                                )
                            })}
                        </Slider>
                    </div>

                    {/* slider end */}
                    <div className='post_img_box container mobHidden'>
                        <div className='row post_img_internal_box'>
                            {posts.postImages.slice(0, 2).map((image, ind) => {
                                return (
                                    <div className={`post_child_div ${posts.postImages.length === 1 ? 'col-12' : 'col-md-6'}`} key={ind} onClick={() => handleSliderShow(image)}>
                                        <div className="post_img mb-3 "><img src={image.url} alt="" /></div>
                                    </div>
                                );
                            })}
                            {posts.postImages.slice(2, 4).map((image, ind) => {
                                return (
                                    <div className={`post_child_div ${posts.postImages.length === 1 ? 'col-12' : 'col-md-4'}`} key={ind + 2} onClick={() => handleSliderShow(image)}>
                                        <div className="post_img mb-3 "><img src={image.url} alt="" /></div>
                                    </div>
                                );
                            })}
                            {posts.postImages.slice(4, 5).map((image, ind) => {
                                return (
                                    <div className={`post_child_div ${posts.postImages.length === 1 ? 'col-12' : 'col-md-4'}`} key={ind + 4} onClick={() => handleSliderShow(image)}>
                                        {
                                            posts.postImages.length > 5 &&
                                            <span>{`${posts.postImages.length - 5}+`}</span>
                                        }
                                        <div className="post_img mb-3 " ><img src={image.url} alt="" /></div>
                                    </div>
                                );
                            })}

                            {posts.postVideos.map((video, ind) => {
                                return (
                                    <div className={`post_main_div ${posts.postVideos.length === 1 ? 'col-12' : 'col-md-4'}`} key={ind + 5} onClick={() => handleSliderShow(video)} >
                                        <Link to="#" className='cp_video_play' >
                                            <img src={videoPlay} />
                                        </Link>
                                        <div className="post_img mb-3 ">
                                            <video controls>
                                                <source src={video.url} type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
                <div className="post_foot">
                    <div className="post_actions">
                        <ul className="ps_links">
                            <li>
                                <Link to="#" onClick={(e) => isLikedByMe ? removeFromLiked(posts.id, e) : addToLiked(posts.id, e)}>
                                    <img src={isLikedByMe ? redHeartIcon : heartIconBordered} alt="" /> {likes}
                                </Link>
                                <Link
                                    to="#"
                                    role="button"
                                    aria-expanded={isCommentsOpen}
                                    aria-controls={`collapseComment${posts.id}`}
                                    onClick={toggleCommentCollapse}
                                >
                                    <i className="post_icon ps_comment"></i> {commentsCount} <span className='mobHidden'>Comments</span>
                                </Link>
                            </li>

                            <li className="ms-auto commReplyActionBtn d-flex align-items-center">
                                <div className="dropdown">
                                    <button
                                    className="btn btn-light btn-sm dropdown-toggle"
                                    type="button"
                                    id="actionMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    >
                                    ⋮
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="actionMenuButton">
                                    {(posts.userId?.id === authInfo.id ||
                                        posts.sellerId?.id === authInfo.id ||
                                        posts.adminId?.id === authInfo.id) ? (
                                        <>
                                        <li>
                                            <button
                                            className="dropdown-item"
                                            onClick={() => {
                                                handleEdit(posts);
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            }}
                                            >
                                            Edit
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => confirmDelete(posts.id)}
                                                >
                                                Delete
                                            </button>
                                        </li>
                                        </>
                                    ) : (
                                        !posts.isAdmin && (
                                        <>
                                            <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleBlockUser(posts)}
                                            >
                                                Block
                                            </button>
                                            </li>
                                            <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleReportPopup(posts)}
                                            >
                                                Report
                                            </button>
                                            </li>
                                        </>
                                        )
                                    )}
                                    <li>
                                        <button
                                        className="dropdown-item"
                                        onClick={() => handleShare(posts)}
                                        >
                                        <i className="post_icon ps_share me-2"></i> Share
                                        </button>
                                    </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>

                        <div ref={shareRef}>
                            {
                                openShare ?
                                    <div className="collapse_pop">
                                        <ul className="shareto">
                                            <li>
                                                <i className="post_icon ps_share"></i>
                                                Share
                                            </li>
                                            <li><Link to="#" onClick={() => handleFacebookShare(posts.id)}>Facebook</Link></li>
                                            <li><Link to="#" onClick={() => handleXShare(posts.id)}>X</Link></li>
                                            <li><Link to="#" onClick={() => handleInstagramShare(posts.id)}>Instagram</Link></li>
                                            <li><Link to="#" onClick={() => handleWhatsappShare(posts.id)}>Whatsapp</Link></li>
                                        </ul>
                                    </div>
                                    : ''
                            }
                        </div>
                        <div className={`collapse post_comments ${isCommentsOpen ? 'show' : ''}`} id={`collapseComment${posts.id}`}>
                            <div className="post_comments__header d-flex justify-content-between align-items-center px-3 pt-3">
                                <span className="fw-semibold">Comments</span>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close comments"
                                    onClick={closeComments}
                                />
                            </div>
                            <ul className="comnt_list">
                                <li>
                                    {commentsArr.slice(0, commentsToShow).map((val, id) => {
                                        return (
                                            // <div
                                            //     className={`commnt_box d-flex mb-3 ${val.userId && val.userId.id === authInfo.id
                                            //         ? 'justify-content-end'
                                            //         : val.sellerId && val.sellerId.id === authInfo.id
                                            //             ? 'justify-content-end'
                                            //             : val.adminId && val.adminId.id === authInfo.id
                                            //                 ? 'justify-content-end'
                                            //                 : 'justify-content-start'
                                            //         }`} key={id}>
                                            <div
                                                className="commnt_box d-flex mb-3 justify-content-start"
                                                key={id}
                                            >
                                                <div className="avtar_img">
                                                    <img className="img-fluid" src={val.isSeller
                                                        ? (val.sellerId && val.sellerId.image_url ? val.sellerId.image_url : userImg)
                                                        : val.isAdmin
                                                            ? (val.adminId && val.adminId.image_url ? val.adminId.image_url : userImg)
                                                            : (val.userId && val.userId.image_url ? val.userId.image_url : userImg)
                                                    } alt="" />
                                                </div>
                                                <div className="commnt_text">
                                                    <div className="commnt_body">
                                                        <div className="commnt_by">
                                                            {val.isSeller
                                                                ? (val.sellerId && val.sellerId.name ? val.sellerId.name : 'N/A')
                                                                : val.isAdmin
                                                                    ? (val.adminId && val.adminId.name ? val.adminId.name : 'N/A')
                                                                    : (val.userId && val.userId.name ? val.userId.name : 'N/A')
                                                            }
                                                            <div className="cb_date"> <ReactTimeAgo date={new Date(val.createdAt)} locale="en-US" timeStyle="round-minute" /></div>
                                                        </div>
                                                        <p><b>{val.content}</b></p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {commentsCount == 0 ? '' :
                                        <button className={`btn load_more_post ${commentsArr.length === commentsToShow || commentsArr.length === commentsToShow - 1 ? 'd-none' : ''}`} onClick={() => viewMoreComments(posts.id)} >view more comments</button>
                                    }
                                </li>

                                <li>
                                    <div className="add_commnt">
                                        <div className="avtar_img">

                                            <img
                                                src={userInfo.imgUrl && userInfo.imgUrl.trim() !== "" ? userInfo.imgUrl : userImg}
                                                alt=""
                                                className="img-fluid"
                                            />
                                        </div>
                                        <div className="add_comnt">
                                            <div className="ac_box">
                                                <textarea className="form-control" placeholder="Add Comment" name="" id="" rows="3" value={comments} onChange={(e) => handleComments(e)}></textarea>
                                                <button type="submit" className="btn btn_yellow custom_btn" onClick={() => addNewComment(posts.id)} disabled={!comments.trim()}>
                                                    Add Comment
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {posts.categoryId !== null && posts.categoryId.categoryName !== '' ? <>
                {/* <div className="row my-3">
                    <div className="col text-center position-relative">
                        <aside className="advertisement-banner position-relative">
                            <span className="small-advertise-tag position-absolute top-0 start-0 bg-dark text-white px-2 py-1 rounded">
                                Advertisement
                            </span> */}
                <CommunityAdvertise keywords={posts.categoryId.categoryName} />
                {/* </aside>
                    </div>
                </div> */}
            </> : <>

            </>}


            <Modal
                show={isReportOpen}
                onHide={() => setIsReportOpen(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div>
                        <p class="text-center fw-bold">Are you sure you want to report ?</p>
                    </div>
                    <div className="">
                        <div className="form-check d-inline-block me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="option1"
                                name="options"
                                value="Please delete this post"
                                checked={reportOption === "Please delete this post"}
                                onChange={handleOptionChange}
                            />
                            <label className="form-check-label" htmlFor="option1">
                                Please delete this post
                            </label>
                        </div> <br />
                        <div className="form-check d-inline-block me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="option1"
                                name="options"
                                value="This post contains inappropriate language"
                                checked={reportOption === "This post contains inappropriate language"}
                                onChange={handleOptionChange}
                            />
                            <label className="form-check-label" htmlFor="option1">
                                This post contains inappropriate language
                            </label>
                        </div> <br />
                        <div className="form-check d-inline-block me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="option2"
                                name="options"
                                value="This post voilates our Terms & Condition"
                                checked={reportOption === "This post voilates our Terms & Condition"}
                                onChange={handleOptionChange}
                            />
                            <label className="form-check-label" htmlFor="option2">
                                This post voilates our Terms & Condition
                            </label>
                        </div> <br />
                    </div>
                    <br />
                    <div className="input-section">
                        <label htmlFor="">Note</label>
                        <div className="field_item text-left mt-2">
                            <textarea
                                type="text"
                                name="note"
                                value={reportNote}
                                onChange={handleNoteChange}
                                cols="30"
                                rows="10"
                                className="form-control"
                            ></textarea>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                        <div className="d-grid gap-2 d-md-block">
                            <button className="btn btn-warning btn-sm" type="button" onClick={handleReportPost}>Send Report</button>
                            <button className="btn btn-secondary btn-sm" type="button" onClick={reportPopupClose}>Cancel</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {isConfirmOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
                <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md mx-4 overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                    <div className="px-6 pt-6 pb-4 border-b border-gray-100">
                        <div className="flex items-center justify-center w-14 h-14 mx-auto mb-4 bg-red-50 rounded-full">

                        </div>
                        <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
                            Delete Post?
                        </h2>
                    </div>

                    <div className="px-6 text-center">
                        <p className="text-gray-600 leading-relaxed mb-4">
                            Are you sure you want to delete this post? 
                        </p>  
                        <button
                            className="btn custum_back_btn me-3"
                            onClick={() => setIsConfirmOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn custum_back_btn btn_yellow"
                            onClick={() => handleRemove(selectedPostId)}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        )}

        </React.Fragment>
    );
};

export default Post;
